/* assets/letter-fade.js */
(function () {
    const DEFAULTS = {
        minOpacity: 0.3,
        maxOpacity: 1.0,
        window: 0.1,
        smoothing: 0.2,
        direction: 'forward',
        endVh: 0.2,
    };

    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const lerp = (a, b, t) => a + (b - a) * t;

    // Progress: 0 when element enters from bottom, 1 when bottom hits endVh from top.
    function makeProgressFn(el, endVhFraction) {
        return function getProgress() {
            const r = el.getBoundingClientRect();
            const vhStart = window.innerHeight; // bottom
            const vhEnd = endVhFraction * window.innerHeight; // e.g. 20% from top
            const f = r.top - vhStart; // = 0 at start
            const g = r.bottom - vhEnd; // = 0 at end
            let denom = f - g;
            if (Math.abs(denom) < 1) denom = denom >= 0 ? 1 : -1; // avoid div/0
            const p = f / denom;
            return clamp01(p);
        };
    }

    function wrapTextNodes(root) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
            acceptNode: (n) => (n.nodeValue && n.nodeValue.length ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
        });
        const textNodes = [];
        let node;
        while ((node = walker.nextNode())) textNodes.push(node);

        let totalChars = 0;
        textNodes.forEach((tn) => {
            const s = tn.nodeValue || '';
            for (let i = 0; i < s.length; i++) if (!/\s/.test(s[i])) totalChars++;
        });

        let idxNonWs = 0;
        textNodes.forEach((tn) => {
            const s = tn.nodeValue || '';
            const frag = document.createDocumentFragment();
            for (let i = 0; i < s.length; i++) {
                const ch = s[i];
                const span = document.createElement('span');
                span.className = 'lf-char';
                span.textContent = ch;
                if (!/\s/.test(ch)) {
                    span.dataset.charIndex = String(idxNonWs++);
                } else {
                    span.dataset.space = '1';
                }
                frag.appendChild(span);
            }
            tn.parentNode.replaceChild(frag, tn);
        });

        const chars = Array.from(root.querySelectorAll('.lf-char')).filter((s) => !s.dataset.space);
        return { totalChars, chars };
    }

    function init(root) {
        if (!root || root.dataset.lfInited) return;
        root.dataset.lfInited = '1';

        const opts = {
            minOpacity: Number(root.dataset.letterMinOpacity || DEFAULTS.minOpacity),
            maxOpacity: Number(root.dataset.letterMaxOpacity || DEFAULTS.maxOpacity),
            window: Number(root.dataset.letterWindow || DEFAULTS.window),
            smoothing: Number(root.dataset.letterSmoothing || DEFAULTS.smoothing),
            direction: (root.dataset.letterDirection || DEFAULTS.direction).toLowerCase(),
            endVh: Math.max(0, Math.min(1, Number(root.dataset.letterEndVh || DEFAULTS.endVh))),
        };

        const { totalChars, chars } = wrapTextNodes(root);
        if (!totalChars || !chars.length) return;

        // Start dim
        chars.forEach((s) => {
            s.style.willChange = 'opacity';
            s.style.display = 'inline';
            s.style.opacity = String(opts.minOpacity);
        });

        // Per-char timing; clamp end ≤ 1 so the last chars can fully complete.
        const minWindow = Math.max(opts.window, 1 / totalChars); // guarantees some width
        const info = chars.map((span, forwardIndex) => {
            const orderIndex = opts.direction === 'reverse' ? totalChars - 1 - forwardIndex : forwardIndex;
            const start = orderIndex / totalChars;
            const unclampedEnd = start + minWindow;
            const end = unclampedEnd > 1 ? 1 : unclampedEnd;
            return { span, start, end, current: opts.minOpacity };
        });

        const getProgress = makeProgressFn(root, opts.endVh);

        let rafId = null;
        const frame = () => {
            const p = getProgress(); // 0..1

            // If we've reached the end, snap everything to max (bypass smoothing)
            if (p >= 1) {
                for (let i = 0; i < info.length; i++) {
                    const it = info[i];
                    it.current = opts.maxOpacity;
                    it.span.style.opacity = String(opts.maxOpacity);
                }
                rafId = requestAnimationFrame(frame);
                return;
            }

            for (let i = 0; i < info.length; i++) {
                const it = info[i];
                let target;
                if (p <= it.start) {
                    target = opts.minOpacity;
                } else if (p >= it.end) {
                    target = opts.maxOpacity;
                } else {
                    const t = (p - it.start) / Math.max(1e-6, it.end - it.start);
                    target = lerp(opts.minOpacity, opts.maxOpacity, t);
                }
                it.current = it.current + (target - it.current) * opts.smoothing;
                it.span.style.opacity = it.current.toFixed(3);
            }
            rafId = requestAnimationFrame(frame);
        };
        rafId = requestAnimationFrame(frame);

        // Cleanup on removal
        const mo = new MutationObserver(() => {
            if (!document.body.contains(root)) {
                cancelAnimationFrame(rafId);
                mo.disconnect();
            }
        });
        mo.observe(document.body, { childList: true, subtree: true });
    }

    function boot(scope = document) {
        scope.querySelectorAll('[data-letter-fade]').forEach(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
        boot(document);
    }

    // Shopify Theme Editor support
    document.addEventListener('shopify:section:load', (e) => {
        boot(e.target || e.detail?.sectionElement || document);
    });
    document.addEventListener('shopify:section:select', (e) => {
        boot(e.target || e.detail?.sectionElement || document);
    });
})();
